@if (display) {
    <footer class="container mx-auto bg-surface-900 px-6 pt-20 py-10 md:px-12 lg:px-20">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <div class="sm:col-span-2 lg:col-span-1 mb-8">
                <a
                class="flex items-center gap-4"
                [href]="marketingSite"
                target="_blank">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    class="h-11 w-11"
                    fill="none"
                    style="enable-background:new 0 0 512 512;">
                        <style type="text/css">
                            .st0{fill:#ffffff;}
                            .st1{fill:var(--color-brand-blue);}
                            .st2{fill:var(--color-brand-green);}
                        </style>
                        <g>
                            <path class="st1" d="
                                M80,0
                                h214
                                v376
                                h-296
                                v-296 a80,80 0 0 1 80,-80
                                z"
                            />

                            <path class="st0" d="
                                M295,0
                                h38
                                v412
                                h-335
                                v-38
                                h295
                                v-432
                                z"
                            />

                            <path class="st2" d="
                                M332,0
                                h100 a80,80 0 0 1 80,80
                                v352 a80,80 0 0 1 -80,80
                                h-352 a80,80 0 0 1 -80,-80
                                v-20
                                h332
                                v-432
                                z"
                            />
                        </g>
                    </svg>

                    <div class="">
                        <span class="text-surface-0 text-lg font-semibold leading-tight">
                            {{ appName }}
                        </span>

                        <p class="text-surface-400">
                            {{ appSlogan }}
                        </p>
                    </div>
                </a>
            </div>

            <div class="lg:ms-auto">
                <div class="text-surface-400 font-bold leading-tight mb-5">
                    Services
                </div>

                <div class="flex flex-col gap-4">
                    @for (item of serviceItems; track item.key) {
                        @if (item.value.includes('http')) {
                            <a
                            class="text-surface-200 hover:text-surface-0 leading-tight transition-colors cursor-pointer"
                            [href]="item.value"
                            target="_blank">
                                {{ item.key }}
                            </a>
                        } @else {
                            <a
                            class="text-surface-200 hover:text-surface-0 leading-tight transition-colors cursor-pointer"
                            [routerLink]="item.value">
                                {{ item.key }}
                            </a>
                        }
                    }
                </div>
            </div>

            <div class="lg:ms-auto">
                <div class="text-surface-400 font-bold leading-tight mb-5">
                    Company
                </div>

                <div class="flex flex-col gap-4">
                    @for (item of resourceItems; track item.key) {
                        @if (item.value.includes('http')) {
                            <a
                            class="text-surface-200 hover:text-surface-0 leading-tight transition-colors cursor-pointer"
                            [href]="item.value"
                            target="_blank">
                                {{ item.key }}
                            </a>
                        } @else {
                            <a
                            class="text-surface-200 hover:text-surface-0 leading-tight transition-colors cursor-pointer"
                            [routerLink]="item.value">
                                {{ item.key }}
                            </a>
                        }
                    }
                </div>
            </div>

            <!-- <div class="sm:col-span-2 lg:col-span-1">
                <div class="flex flex-col gap-2">
                    <div class="text-surface-0 leading-normal">Jacob Obrechtstraat 5, 1071 KC Amsterdam The Netherlands</div>
                    <div class="text-surface-0 leading-tight">(31) 20 779 8986</div>
                    <div class="text-surface-0 leading-tight">hello@bastion.co</div>
                </div>
            </div> -->
        </div>

        <div class="flex justify-between text-surface-400 mt-10">
            <sas-copyright></sas-copyright>
            
            <span>{{ appName }} v{{ appVersion }}</span>
        </div>
    </footer>
}
